// Display-only JWT payload decode (NOT signature verification — the backend
// verifies the token on every request; this just reads claims for the UI).
// The admin access token carries { sub, role, tenant_id, is_employee } — enough
// to show the User ID after a cold refresh, where /refresh + /permissions don't
// return identity. Email is NOT in the token, so it still needs an interactive login.

export interface JwtClaims {
  sub?: string;
  role?: string;
  tenant_id?: string | null;
}

export function decodeJwtClaims(token: string | null): JwtClaims | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const claims = JSON.parse(json) as Record<string, unknown>;
    return {
      sub: typeof claims.sub === 'string' ? claims.sub : undefined,
      role: typeof claims.role === 'string' ? claims.role : undefined,
      tenant_id: typeof claims.tenant_id === 'string' ? claims.tenant_id : null,
    };
  } catch {
    return null;
  }
}
